import * as React from 'react';

import { useGetTestId } from '@/hooks';
import { cn } from '@/lib/utils';

interface TextareaProps extends React.ComponentProps<'textarea'> {
  placeholderClassName?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, placeholderClassName, ...props }, ref) => {
    const testId = useGetTestId(props.name);

    return (
      <div className="flex w-full flex-col gap-2 relative">
        <textarea
          className={cn(
            'flex min-h-[160px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            className
          )}
          ref={ref}
          data-testid={testId}
          {...props}
          placeholder=""
        />
        {props.maxLength && (
          <span className="text-zinc-50 text-sm bottom-[8px] right-[12px] self-end">
            {props?.value?.toString()?.length}/{props.maxLength}
          </span>
        )}
        {!props.value && (
          <span
            className={cn(
              'text-sm text-muted-foreground font-normal absolute left-[13px] top-[9px]',
              placeholderClassName
            )}
          >
            {props.placeholder}
          </span>
        )}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
